import React from 'react'
import PropTypes from 'prop-types'

// HOC for a step component.
function StepWrapper({
  className,
  stepNum,
  currentStep,
  currentProgress,
  children,
}) {
  const isActive = (currentStep === stepNum);
  const isVisited = (currentProgress >= stepNum);

  return (
    <div
      className={`mz-step-item-wrapper ${className}`}
      aria-hidden={!isActive}
    >
      {/* Render children when it's either active or already visited */}
      {(isActive || isVisited) && (
        children
      )}
    </div>
  )
}

StepWrapper.propTypes = {
  className: PropTypes.string,
  stepNum: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  currentProgress: PropTypes.number.isRequired,
}

StepWrapper.defaultProps = {
  className: '',
  stepNum: 1,
  currentStep: 1,
  currentProgress: 1,
}

export default StepWrapper

